import restfulBase from '@/services/negotiations/core/base';

const apiService = restfulBase('companies');

export default apiService;
